import { Component, OnInit } from '@angular/core';
import { PopUpComponent } from '../bank-management/pop-up/pop-up.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-coming-soon-popup',
  templateUrl: './coming-soon-popup.component.html',
  styleUrls: ['./coming-soon-popup.component.scss']
})
export class ComingSoonPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PopUpComponent>) {
   
   }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
